import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { GENERIC_WITHDRAWAL_NUMBER } from '@constants/funds-withdrawal.constant';
import { OLD_ROUTES_REDIRECTIONS } from '@constants/old-routes-redirections.constant';
import {
  getAccessConsultRoute, getBeneficiaryRequestRoute, getForeignRequestRoute,
  getRequestRoute, MAIN_ROUTES
} from '@constants/routes.constant';
import { EnabledWithdrawalGuard } from './guards/enabled-withdrawal.guard';

const actualRoutes: Routes = [
  { path: '', loadChildren: () => import('./modules/home/home.module').then(m => m.HomePageModule) },
  {
    path: getRequestRoute(MAIN_ROUTES.THIRD_WITHDRAWAL),
    loadChildren: () => import('./modules/generic-funds-withdrawal/generic-withdrawal-funds-withdrawal.module')
      .then(m => m.GenericWithdrawalFundsWithdrawalPageModule),
      canActivate: [EnabledWithdrawalGuard],
      data: { withdrawalNumber: GENERIC_WITHDRAWAL_NUMBER.THIRD }
  },
  {
    path: `${getRequestRoute(MAIN_ROUTES.THIRD_WITHDRAWAL)}/:id`,
    loadChildren: () => import('./modules/generic-funds-withdrawal/generic-withdrawal-funds-withdrawal.module')
      .then(m => m.GenericWithdrawalFundsWithdrawalPageModule),
      canActivate: [EnabledWithdrawalGuard],
      data: { withdrawalNumber: GENERIC_WITHDRAWAL_NUMBER.THIRD }
  },
  {
    path: getBeneficiaryRequestRoute(MAIN_ROUTES.THIRD_WITHDRAWAL),
    loadChildren: () => import('./modules/generic-funds-withdrawal/generic-withdrawal-funds-withdrawal.module')
      .then(m => m.GenericWithdrawalFundsWithdrawalPageModule),
      canActivate: [EnabledWithdrawalGuard],
      data: { withdrawalNumber: GENERIC_WITHDRAWAL_NUMBER.THIRD }
  },
  {
    path: getRequestRoute(MAIN_ROUTES.FISCAL_BONUS),
    loadChildren: () => import('./modules/fiscal-bonus/first-fiscal-bonus.module')
      .then(m => m.FirstFiscalBonusPageModule),
      canActivate: [EnabledWithdrawalGuard],
      data: { withdrawalNumber: GENERIC_WITHDRAWAL_NUMBER.FIRST_BONUS }
  },
  {
    path: `${getRequestRoute(MAIN_ROUTES.FISCAL_BONUS)}/:id`,
    loadChildren: () => import('./modules/fiscal-bonus/first-fiscal-bonus.module')
      .then(m => m.FirstFiscalBonusPageModule),
      canActivate: [EnabledWithdrawalGuard],
      data: { withdrawalNumber: GENERIC_WITHDRAWAL_NUMBER.FIRST_BONUS }
  },
  {
    path: getBeneficiaryRequestRoute(MAIN_ROUTES.FISCAL_BONUS),
    loadChildren: () => import('./modules/fiscal-bonus/first-fiscal-bonus.module')
      .then(m => m.FirstFiscalBonusPageModule),
      canActivate: [EnabledWithdrawalGuard],
      data: { withdrawalNumber: GENERIC_WITHDRAWAL_NUMBER.FIRST_BONUS }
  },
  {
    path: getForeignRequestRoute(MAIN_ROUTES.THIRD_WITHDRAWAL),
    loadChildren: () => import('./modules/generic-foreign-funds-withdrawal/generic-foreign-funds-withdrawal.module')
      .then(m => m.GenericForeignFundsWithdrawalPageModule),
      canActivate: [EnabledWithdrawalGuard],
      data: { withdrawalNumber: GENERIC_WITHDRAWAL_NUMBER.THIRD }
  },
  {
    path: getForeignRequestRoute(MAIN_ROUTES.FISCAL_BONUS),
    loadChildren: () => import('./modules/fiscal-foreign-bonus/fiscal-foreign-bonus.module')
      .then(m => m.FiscalForeignBonusPageModule),
      canActivate: [EnabledWithdrawalGuard],
      data: { withdrawalNumber: GENERIC_WITHDRAWAL_NUMBER.FIRST_BONUS }
  },
  {
    path: getAccessConsultRoute(MAIN_ROUTES.FISCAL_BONUS),
    loadChildren: () => import('./modules/fiscal-bonus-request/fiscal-bonus-request.module')
      .then( m => m.FiscalBonusRequestPageModule),
      canActivate: [EnabledWithdrawalGuard],
      data: { withdrawalNumber: GENERIC_WITHDRAWAL_NUMBER.FIRST_BONUS }
  },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];

const routes: Routes = [...OLD_ROUTES_REDIRECTIONS, ...actualRoutes];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, scrollOffset: [0, 0], scrollPositionRestoration: 'top' })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
